import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productList: [],
  productDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    clearError(state) {
      state.loading = false;
      state.success = false;
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchProductList(state, action) {
      state.productList = action.payload;
      state.loading = false;
    },
    fetchProductDetail(state, action) {
      state.productDetail = action.payload;
      state.loading = false;
    },
  },
});

export const productActions = productSlice.actions;

export default productSlice.reducer;
